<div *ngIf="cargado">
  <mat-toolbar class="mat-toolbar-azul">
    <img *ngIf="cargado" [src]="logoVisorWeb" width="250" height="auto" fxHide.xs>
    <img *ngIf="cargado" [src]="logoVisorWeb" width="200" height="90%" fxHide.xs fxHide.sm fxHide.lg
      fxHide.md fxHide.xl>
      <span class="text-container">Datos Generales del Presupuesto</span>
    <button mat-icon-button (click)="closeDialogDatosGeneralesPresupuesto()" class="menu-button">
      <mat-icon matSuffix>close</mat-icon>
    </button>
  </mat-toolbar>
  <mat-card class="card-grey">
    <mat-card-content>
      <form [formGroup]="datosGeneralesPresupuestoForm" (ngSubmit)="onSubmit()">
        <div fxLayout="row" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.xs="column" class="divconten-datosgral"
          style="justify-content: start !important;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Indica una Empresa" appearance="outline"
            [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'" floatLabel="always">
              <mat-label>Empresa:</mat-label>
              <mat-select formControlName="nombreEmpresa" required placeholder="Seleccione una opción">
                <mat-option *ngFor="let item of listEmpresas" [value]="item.id">{{item.value}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>apartment</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreEmpresa'].hasError('required')">Empresa es
                requerido.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten-datosgral" style="padding-top: 15px;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Indica un título" appearance="outline"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'"
              floatLabel="always">
              <mat-label>Título de Obra</mat-label>
              <mat-select formControlName="tituloObra" placeholder="Seleccione una opción">
                <mat-option *ngFor="let item of listTitulosObras" [value]="item.id">{{item.value}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>work</mat-icon>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Indica el precio" appearance="outline"
              [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'"
              floatLabel="always">
              <mat-label>Capturar Precios</mat-label>
              <mat-select formControlName="capturaPrecios" placeholder="Seleccione una opción">
                <mat-option *ngFor="let item of listCapturaPrecios" [value]="item.id">{{item.value}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>payments</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
          class="divconten-datosgral" style="padding-top: 15px;">
            <mat-form-field fxLayout="column" fxFlex="grow" fxFlex.xs="grow" fxFlex.sm="grow" fxFlex.md="grow"
              hintLabel="Ingrese nombre presupuesto" appearance="outline" floatLabel="always" [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'">
              <mat-label>Nombre del Presupuesto:</mat-label>
              <input matInput formControlName="nombrePresupuesto" name="nombrePresupuesto" minlength="4" maxlength="250"
                autocomplete="off" required>
              <mat-icon matSuffix>description</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombrePresupuesto'].hasError('required')">Nombre
                presupuesto es
                requerido.</mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['nombrePresupuesto'].hasError('minlength')">Nombre
                presupuesto debe
                ser mínimo 4 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['nombrePresupuesto'].hasError('maxlength')">Nombre
                presupuesto debe
                ser máximo 250 caracteres.
              </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
          class="divconten-datosgral" style="padding-top: 15px;">
            <mat-form-field fxLayout="column" fxFlex="grow" appearance="outline" floatLabel="always"
              hintLabel="Ingrese descripción presupuesto" [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'">
              <mat-label>Descripción:</mat-label>
              <textarea matInput formControlName="descripcionPresupuesto" name="descripcionPresupuesto"
                cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"></textarea>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionPresupuesto'].hasError('minlength')">Descripción
                presupuesto debe ser mínimo 10 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionPresupuesto'].hasError('maxlength')">Descripción
                presupuesto debe ser máximo 250 caracteres.
              </mat-error>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
          class="divconten-datosgral" style="padding-top: 15px;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese Ubicación" appearance="outline" floatLabel="always"
            [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'">
              <mat-label>Ubicación, Condiciones, Validez:</mat-label>
              <input matInput formControlName="ubicacionCondicionesValidez" name="ubicacionCondicionesValidez"
                minlength="4" maxlength="100" autocomplete="off">
              <mat-icon matSuffix>location_on</mat-icon>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['ubicacionCondicionesValidez'].hasError('minlength')">Campo
                debe
                ser mínimo 4 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['ubicacionCondicionesValidez'].hasError('maxlength')">Campo
                debe
                ser máximo 100 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese contratante del presupuesto" appearance="outline"
              floatLabel="always" [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'">
              <mat-label>Contratante:</mat-label>
              <input matInput formControlName="contratante" name="contratante" minlength="4" maxlength="100"
                autocomplete="off" required>
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['contratante'].hasError('required')">Contratante
                es
                requerido.</mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['contratante'].hasError('minlength')">Contratante
                debe
                ser mínimo 4 caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['contratante'].hasError('maxlength')">Contratante
                debe
                ser máximo 100 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
          class="divconten-datosgral" style="padding-top: 15px;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese el número de contrato" appearance="outline"
            [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'" floatLabel="always">
              <mat-label>Número de Contrato:</mat-label>
              <input matInput formControlName="numContrato" name="numContrato" minlength="4" maxlength="14" autocomplete="off">
              <mat-icon matSuffix>pin</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['numContrato'].hasError('minlength')">Contrato
                debe
                ser mínimo 4
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['numContrato'].hasError('maxlength')">Contrato
                debe
                ser máximo 14
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Seleccione fecha presupuesto" appearance="outline"
            [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'" floatLabel="always">
              <mat-label>Fecha del Presupuesto:</mat-label>
              <input matInput formControlName="fechaPresupuesto" [matDatepicker]="pickerStart" [min]="minDate" readonly
                (click)="pickerStart.open()">
              <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
              <mat-datepicker #pickerStart [disabled]="false"></mat-datepicker>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['fechaPresupuesto'].hasError('invalid')">Fecha
                presupuesto es
                inválida.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
          class="divconten-datosgral" style="padding-top: 15px;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Indica si aplica I.V.A" appearance="outline"
            [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'" floatLabel="always">
              <mat-label>Opción I.V.A.</mat-label>
              <mat-select formControlName="aplicarIva" placeholder="Seleccione una opción">
                <mat-option *ngFor="let item of listOpcionesIva" [value]="item.id">{{item.value}}</mat-option>
              </mat-select>
              <mat-icon matSuffix>percent</mat-icon>
              </mat-form-field>
              </div>
              <div>
                <mat-form-field fxLayout="column" hintLabel="Indica si reemplaza precios" appearance="outline"
                  [ngClass]="classFlag ? 'input-width-240' : 'input-width-350'"
                  floatLabel="always">
                  <mat-label>Opción Reemplazar Precios</mat-label>
                  <mat-select formControlName="reemplazarPrecios" placeholder="Seleccione una opción">
                    <mat-option *ngFor="let item of listReemplazarPrecios" [value]="item.id">{{item.value}}</mat-option>
                  </mat-select>
                  <mat-icon matSuffix>move_up</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <br />
      <div class="divconten-datosgral" fxLayoutAlign="start start" style="padding-top: 0px;"><mat-label>Firma No
          1:</mat-label></div>
      <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-datosgral"
          style="border: 1px solid black !important; border-radius: 5px !important; padding: 20px !important;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese un nombre" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>Nombre:</mat-label>
              <input matInput formControlName="nombreFirmaUno" name="nombreFirmaUno" minlength="4" maxlength="20"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaUno'].hasError('minlength')">Debe ser
                mínimo 4
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaUno'].hasError('maxlength')">Debe ser
                máximo 20
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline"
              class="input-width-200" floatLabel="always">
              <mat-label>Descripción:</mat-label>
              <input matInput formControlName="descripcionFirmaUno" name="descripcionFirmaUno" minlength="4"
                maxlength="20" autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaUno'].hasError('minlength')">Debe
                debe ser
                mínimo 4 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaUno'].hasError('maxlength')">Debe
                ser
                máximo 20 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>CIV / CI:</mat-label>
              <input matInput formControlName="civFirmaUno" name="civFirmaUno" minlength="5" maxlength="10"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaUno'].hasError('pattern')">Debe ser solo
                números.</mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaUno'].hasError('minlength')">Debe ser
                mínimo
                5
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaUno'].hasError('maxlength')">Debe ser
                máximo
                10
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <br />
        <div class="divconten-datosgral" fxLayoutAlign="start start" style="padding-top: 0px;"><mat-label>Firma No
            2:</mat-label></div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-datosgral"
          style="border: 1px solid black !important; border-radius: 5px !important; padding: 20px !important;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese nombre" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>Nombre:</mat-label>
              <input matInput formControlName="nombreFirmaDos" name="nombreFirmaDos" minlength="4" maxlength="20"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaDos'].hasError('minlength')">Debe ser
                mínimo 4
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaDos'].hasError('maxlength')">Debe ser
                máximo 20
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline"
              class="input-width-200" floatLabel="always">
              <mat-label>Descripción:</mat-label>
              <input matInput formControlName="descripcionFirmaDos" name="descripcionFirmaDos" minlength="4"
                maxlength="20" autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaDos'].hasError('minlength')">Debe
                ser
                mínimo 4 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaDos'].hasError('maxlength')">Debe
                ser
                máximo 20 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>CIV / CI:</mat-label>
              <input matInput formControlName="civFirmaDos" name="civFirmaDos" minlength="5" maxlength="10"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaDos'].hasError('pattern')">Debe ser solo
                números.</mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaDos'].hasError('minlength')">Debe ser
                mínimo
                5
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaDos'].hasError('maxlength')">Debe ser
                máximo
                10
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <br />
        <div class="divconten-datosgral" fxLayoutAlign="start start" style="padding-top: 0px;"><mat-label>Firma No
            3:</mat-label></div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-datosgral"
          style="border: 1px solid black !important; border-radius: 5px !important; padding: 20px;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese nombre" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>Nombre:</mat-label>
              <input matInput formControlName="nombreFirmaTres" name="nombreFirmaTres" minlength="4" maxlength="20"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaTres'].hasError('minlength')">Debe
                ser
                mínimo 4
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaTres'].hasError('maxlength')">Debe
                ser
                máximo 20
                caracteres.</mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline"
              class="input-width-200" floatLabel="always">
              <mat-label>Descripción:</mat-label>
              <input matInput formControlName="descripcionFirmaTres" name="descripcionFirmaTres" minlength="3"
                maxlength="20" autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaTres'].hasError('minlength')">Debe
                ser
                mínimo 4 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaTres'].hasError('maxlength')">Debe
                ser
                máximo 20 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>CIV / CI:</mat-label>
              <input matInput formControlName="civFirmaTres" name="civFirmaTres" minlength="5" maxlength="10"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaTres'].hasError('pattern')">Debe ser
                solo
                números.</mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaTres'].hasError('minlength')">Debe ser
                mínimo 5
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaTres'].hasError('maxlength')">Debe ser
                máximo 10
                caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <br />
        <div class="divconten-datosgral" fxLayoutAlign="start start" style="padding-top: 0px;"><mat-label>Firma No
            4:</mat-label></div>
        <div fxLayout="row" fxLayoutGap="20px" fxLayout.sm="column"
          fxLayout.xs="column" class="divconten-datosgral"
          style="border: 1px solid black !important; border-radius: 5px !important; padding: 20px;">
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese nomobre" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>Nombre:</mat-label>
              <input matInput formControlName="nombreFirmaCuatro" name="nombreFirmaCuatro" minlength="4" maxlength="20"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaCuatro'].hasError('minlength')">Debe
                ser
                mínimo
                4 caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['nombreFirmaCuatro'].hasError('maxlength')">Debe
                ser
                máximo
                20 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline"
              class="input-width-200" floatLabel="always">
              <mat-label>Descripción:</mat-label>
              <input matInput formControlName="descripcionFirmaCuatro" name="descripcionFirmaCuatro" minlength="4"
                maxlength="20" autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaCuatro'].hasError('minlength')">Debe
                ser
                mínimo 4 caracteres.
              </mat-error>
              <mat-error
                *ngIf="datosGeneralesPresupuestoForm.controls['descripcionFirmaCuatro'].hasError('maxlength')">Debe
                ser
                máximo 20 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-200"
              floatLabel="always">
              <mat-label>CIV / CI:</mat-label>
              <input matInput formControlName="civFirmaCuatro" name="civFirmaCuatro" minlength="5" maxlength="10"
                autocomplete="off">
              <mat-icon matSuffix>person</mat-icon>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaCuatro'].hasError('pattern')">Debe ser
                solo
                números.</mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaCuatro'].hasError('minlength')">Debe ser
                mínimo 5
                caracteres.
              </mat-error>
              <mat-error *ngIf="datosGeneralesPresupuestoForm.controls['civFirmaCuatro'].hasError('maxlength')">Debe ser
                máximo
                10 caracteres.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
          class="divconten-datosgral">
          <div fxLayout="column">
            <button mat-raised-button class="buttons-text-center" color="warn" type="button"
              (click)="closeDialogDatosGeneralesPresupuesto()"
              class="align-center-middle">
              <span class="text-icon-space">Regresar</span>
              <mat-icon>restart_alt</mat-icon>
            </button>
          </div>
          <div fxLayout="column" *ngIf="editar">
            <button mat-raised-button class="buttons-text-center" color="primary" type="button" (click)="habilitarCampos()"
              class="align-center-middle">
              <span class="text-icon-space">Editar</span>
              <mat-icon>save</mat-icon>
            </button>
          </div>
          <div fxLayout="column" *ngIf="!editar">
            <button mat-raised-button class="buttons-text-center" color="primary" type="summit" class="align-center-middle">
              <span class="text-icon-space">Guardar</span>
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>